import React from 'react';
import type { RouteObject } from 'react-router-dom';

import { PrivateLayout } from 'src/layouts';
import { DashboardScreen } from 'src/screens/privateScreens';

import { NotFound } from 'src/screens/NotFound';

import PageScreen from 'src/screens/privateScreens/page'
import SettingPageScreen from 'src/screens/privateScreens/sessionPage'
import ContentPageScreen from 'src/screens/privateScreens/contentPage'

import MailtoSettingScreen from 'src/screens/privateScreens/mailtoSetting';

// const CaseStudyScreen = React.lazy(
//   async () =>
//     await import('src/screens/privateScreens/caseStudy').then((module) => ({
//       default: module.default
//     }))
// );

// const DashboardScreen = React.lazy(
//   async () =>
//     await import('src/screens/privateScreens').then((module) => ({
//       default: module.DashboardScreen
//     }))
// );

// const NotFoundScreen = React.lazy(
//   async () =>
//     await import('src/screens/NotFound').then((module) => ({
//       default: module.NotFound
//     }))
// );

const _privateRoutes: RouteObject[] = [
  {
    element: <PrivateLayout />,
    children: [
      { path: '/', element: <DashboardScreen /> },
      { path: '/homes', element: <DashboardScreen /> },

      // { path: '/case_studies', element: <CaseStudyScreen /> },
      { path: '/page', element: <PageScreen /> },
      { path: '/page/:pageId', element: <SettingPageScreen /> },
      { path: '/page/:pageId/:sessionId', element: <ContentPageScreen /> },

      { path: '/mail-setting', element: <MailtoSettingScreen /> },
      { path: '*', element: <NotFound /> }
    ]
  },
];

export default _privateRoutes;
